
import { Vue } from "vue-class-component";

export default class EyeRed extends Vue {}
